<template>
  <Walkthrough 
    roomName="The Garage"
    roomKey="garage"
    :steps="steps"
    :backgroundImage="backgroundImage"
  />
</template>
<script>

export default {
  name: 'JailCell',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/garage-1920x1280.jpg",
      steps: [
          "Look right, and then inspect the shelves where you should find a cloth and a bucket.",
          "Look Left and inspect the motorcycle. You notice that it is leaking so you should capture some of that oil to power the generator.",
          "While looking left, use the bucket on the motorcycle to fill it up. ",
          "Look right and use the bucket on the generator. Then, try to use the generator.",
          "Without the pullcord, the generator won’t start. Use the rope on the generator as a makeshift pullcord. The generator should start now and bring some power to the room.",
          "Look forward and use the cloth on the garage door in order to clean the windows. You realize that you are on HIDE st. This should help with the toolbox.",
          "Look down and inspect the toolbox.",
          "Enter the code 8 - 9 - 4 - 5 (H I D E). The toolbox should open and you will find some grease. ",
          "Look right, inspect the shelves, and inspect the tape player. You should hear some morse code. This is the code for the circuit breaker!",
          "Look left, and inspect the circuit breaker. ",
          "Connect the wires RED, WHITE, BLUE, GREEN and power should come on in the room.",
          "Look up and use the grease on the garage door opener to make it operate smoothly.",
          "Lastly, look forward, and use the button to open the garage door and ESCAPE! toolbox.",
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/garage.vue